<div class="upload-wrapper" [class.disabled]="disabled">
  <label [for]="id" tabindex="0" role="button"  class="button" [class.disabled]="disabled"><i class="icon-file-plus"></i><span>{{ filename? filename : (label | translate) }}</span></label>
  <input type="file" [id]="id" class="show-for-sr" tabindex="-1" (keydown.enter)="fileChanged(file)" (change)="fileChanged(file)" #file [accept]="accept" >
</div>
